import AuthLayout from "layouts/AuthLayout";
import AdminLayout from "layouts/AdminLayout";
import Home from "views/Home";
import Dashboard from "views/Dashboard";
import ThermalData from "views/ThermalData";
import BitcoinEarnings from "views/BitcoinEarnings";
import ElectricityData from "views/ElectricityData";
import Miners from "views/Miners";
import Decisions from "views/Decisions";
import Settings from "views/Settings";
import ProjectEarnings from "views/ProjectEarnings";

import DashboardIcon from "components/svg/DashboardIcon";
import ThermalIcon from "components/svg/ThermalIcon";
import BitcoinIcon from "components/svg/BitcoinIcon";
import ElectricityIcon from "components/svg/ElectricityIcon";
import MinerIcon from "components/svg/MinerIcon";
import ProfileIcon from "components/svg/ProfileIcon";
import ProjectIcon from "components/svg/ProjectIcon";

const routes = [
  {
    path: `${process.env.PUBLIC_URL}`,
    element: <AuthLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        element: <AdminLayout />,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/dashboard`,
            name: "Dashboard",
            element: <Dashboard />,
            icon: <DashboardIcon />,
          },
          {
            path: `${process.env.PUBLIC_URL}/thermal-data`,
            name: "Thermal Data",
            element: <ThermalData />,
            icon: <ThermalIcon />,
          },
          {
            path: `${process.env.PUBLIC_URL}/bitcoin-earnings`,
            name: "Bitcoin Earnings",
            element: <BitcoinEarnings />,
            icon: <BitcoinIcon />,
          },
          {
            path: `${process.env.PUBLIC_URL}/electricity-data`,
            name: "Electricity Data",
            element: <ElectricityData />,
            icon: <ElectricityIcon />,
          },
          {
            path: `${process.env.PUBLIC_URL}/project-earnings`,
            name: "Project Earnings",
            element: <ProjectEarnings />,
            icon: <ProjectIcon />,
          },
          {
            path: `${process.env.PUBLIC_URL}/miners`,
            name: "Miners",
            element: <Miners />,
            icon: <MinerIcon />,
            hiddenOnEmptyEan: true,
          },
          {
            path: `${process.env.PUBLIC_URL}/profiles`,
            name: "Profiles",
            element: <Decisions />,
            icon: <ProfileIcon />,
            hiddenOnEmptyEan: true,
          },
          {
            path: `${process.env.PUBLIC_URL}/settings`,
            name: "Settings",
            element: <Settings />,
            hiddenOnNavBar: true,
          },
        ],
      },
    ],
  },
];

export default routes;
